import type { RestorationPlan } from "../../types/dental";

interface BridgeToolboxProps {
  plan: RestorationPlan;
  onUpdatePlan: (planId: string, updates: Partial<RestorationPlan>) => void;
}

export function BridgeToolbox({ plan, onUpdatePlan }: BridgeToolboxProps) {
  return (
    <section className="procedure-toolbox-card card">
      <h3>Bridge Toolbox</h3>

      <div className="field-stack">
        <div className="field-row">
          <label>Bridge Catalog Item</label>
          <input
            type="text"
            value={plan.selectedCatalogItem || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, {
                selectedCatalogItem: e.target.value,
              })
            }
          />
        </div>

        <div className="field-row">
          <label>Material</label>
          <select
            value={plan.material || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { material: e.target.value })
            }
          >
            <option value="">Select material</option>
            <option value="Zirconia">Zirconia</option>
            <option value="Lithium Disilicate">Lithium Disilicate</option>
          </select>
        </div>

        <div className="field-row">
          <label>Target Teeth</label>
          <div>{plan.targetTeeth.join(", ")}</div>
        </div>

        <div className="field-row">
          <label>Connector / Span Notes</label>
          <textarea
            value={plan.spacingNotes || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { spacingNotes: e.target.value })
            }
          />
        </div>

        <div className="field-row">
          <label>Design Notes</label>
          <textarea
            value={plan.designNotes || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { designNotes: e.target.value })
            }
          />
        </div>
      </div>
    </section>
  );
}